import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { B2BTNKLoanSliderComponent } from './b2b-loan-slider.component';
import { TNKUtilitiesModule } from '../../utils/utilities.module';
import { MatSliderModule } from '@angular/material';
export class B2BTNKLoanSliderModule {
/**
 * @return {?}
 */
public static forRoot(): ModuleWithProviders {
    return {
      ngModule: B2BTNKLoanSliderModule,
      providers: [],
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSliderModule,
    TNKUtilitiesModule,
    RouterModule,
  ],
  declarations: [B2BTNKLoanSliderComponent],
  exports: [B2BTNKLoanSliderComponent],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function B2BTNKLoanSliderModule_tsickle_Closure_declarations() {
/** @type {?} */
B2BTNKLoanSliderModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
B2BTNKLoanSliderModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
